import { getFolders, importMaterial } from '@/api/local-material'
import UploadFile from '@/components/upload-file/UploadFile.vue'
import OssUpload from '@/components/oss-upload/OssUpload.vue'
import ImageUpload from '@/components/image-upload/ImageUpload.vue'
import { getWorkers } from '@/api/open'
import api from '@/config/api'

export default {
    components: {
        UploadFile,
        ImageUpload,
        OssUpload
    },
    props: {
        showImportForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    created() {
    
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            rules: {
                pid: [{ required: true, message: '请选择所属目录', trigger: 'change' }],
                worker_id: [{ required: true, message: '请选择上传人', trigger: 'change' }],
                file: [ { required: true, message: '请选择表格文件', trigger: 'change' }],
            },
            actionName: '导入',
            titles: [],
            show: false,
            treeData: [],
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            showSize: 0,
            pid: null,
            materials: [], //上传的多个素材
            materialTags: [],
            workers:[],
            templateUrl: api.baseUrl + '/导入本地素材模板.xlsx?t=2',
            fileList: [],
            zms: [{id:0, name:'不转码'}, {id:1, name:'转码'}],
            // 是否叠加角标 + 拼接片尾（默认选中"加角标+片尾"）
            enhances: [{id:0, name:'不加角标片尾'}, {id:1, name:'加角标+片尾'}],
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
        // console.log('model', this.model)
        //获取所有的目录
        getFolders().then(res => { this.treeData = res.data.list || {} })
        if (this.model.size) {
            this.showSize = Number(this.model.size / 1024 / 1024).toFixed(2)
        }
        getWorkers({type:3}).then(res => {
            this.workers = res.data.list
        })
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            if (!this.model.pid) {
                return this.$message.error('素材禁止' + this.actionName + '到根目录')
            }
            if (!this.model.file){
                return this.$message.error('请上传表格文件')
            }

            const data = new FormData()
            data.append('file', this.model.file)
            data.append('pid', this.model.pid)
            data.append('worker_id', this.model.worker_id)
            data.append('is_zm', this.model.is_zm)
            // 默认开启「角标 + 片尾」（未选择时兜底为 0）
            data.append('is_enhance', this.model.is_enhance == null ? 0 : this.model.is_enhance)
        
            // console.log('提交的数据', data)

            this.loading = true
            importMaterial(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('添加导入任务成功，请等待')
                    // this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$emit('update:showImportForm', false)
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [file];
            this.model.file = file
            return false;
        },
    }
}
